import { Observable } from 'rxjs';

// Allows a variable to be provided synchronously or asynchronously
type OptionalObservable<T> = T | Observable<T>;

export function waitForOptionalObservable<T>(
    optionalObservable: OptionalObservable<T>,
    callback: (data: T) => void // The function to call when the observable completes OR immediately if an observable wasn't provided
): Promise<void> {
    return new Promise((resolve, reject) => {
        // If an observable was provided, wait for it to emit before calling the callback and resolving the promise
        if (optionalObservable instanceof Observable) {
            optionalObservable.subscribe({
                next: (data) => {
                    callback(data);
                    resolve();
                },
                error: () => reject(),
            });
        } else {
            // If an observable was not provided, call the callback immediately and resolve immediately
            callback(optionalObservable);
            resolve();
        }
    });
}

export default OptionalObservable;
